$('#trinket-color').on('change', function () {
	let $self = $(this),
		color = $self.val(),
		$figure = $('.section-constructor-content figure');

	$figure.find('img').addClass('d-none');
	$figure.find('[data-color="' + color + '"]').removeClass('d-none');

	return false;
});

let $formConstructor = $('#form-constructor');

$formConstructor.find('.animal-type').change(function () {
	$formConstructor.find('#constructor-name').attr('placeholder', $(this).data('name-placeholder'));
});

$formConstructor.submit(function () {
	let data = $(this).serializeArray(),
		$modal = $('#modal-constructor'),
		$form = $('#form-constructor-order');

	ModalVegas.init(null, {
		type: 'bootstrap',
		target: '#modal-constructor',
		cloned_container: false,
	});

	// img
	let src = $formConstructor.find('figure.trinket img:not(.d-none)').first().attr('src');
	$modal.find('img').attr('src', src);

	// price
	let price = $formConstructor.find('.price span').html();
	$modal.find('[data-trinket-price]').html(price);

	if (data.length) {
		for (let i = 1; i <= data.length; i++) {
			/*if (data[i - 1].name === 'constructor_color') {
				let text = $formConstructor.find('[name=constructor_color] option[value=' + data[i - 1].value + ']').text();
				$modal.find('.choice-trinket [data-trinket-color]').text(text);
				$form.find('[name=trinket_color]').val(data[i - 1].value);
			}*/

			if (data[i - 1].name === 'constructor_name') {
				$modal.find('.choice-trinket [data-trinket-name]').text(data[i - 1].value);
				$form.find('[name=trinket_name]').val(data[i - 1].value);
			}

			if (data[i - 1].name === 'constructor_animal') {
				let val = '';

				if (data[i - 1].value == 1) {
					val = 'кошки';
				} else if (data[i - 1].value == 2) {
					val = 'собаки';
				}

				$form.find('[name=trinket_pet]').val(data[i-1].value);
				$modal.find('[data-trinket-pet]').text(val);
			}
		}
	}

	return false;
});
